import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatStepper } from "@angular/material/stepper";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { catchError, of, Subject, takeUntil } from "rxjs";
import { CONFIG_MODE, IaConfigStatusBody, IaConfigStatusHeader } from "src/app/core/enums/insightConfigurations.enum";
import { CreateConfigError, EwbAlgorithmList, EwbConfiguration, SelectedKpi, VersionsList } from "src/app/core/models/insight-configuration.model";
import { Step } from "src/app/core/models/Step";
import { MODAL_TITLE, EWB_CONFIG_ERROR, EWB_CONFIG_ERROR_MODAL_MESSAGE, EWB_CREATE_COMPONENTS } from 'src/app/core/enums/ewbConfiguration.enum';
import { ClearEwbConfigState, GetAlgorithmAssetList, GetAlgorithmList, GetJwtToken, GetThemes, MoveStep, RemoveConfiguredAssets, SetAssetsDuplicateDetected, SetEwbMode, SetThresholdUomConfig, SubmitEwbConfiguration, UpdateConfiguraitonDetails } from "src/app/core/store/ewb-configuration/ewb-configuration.action";
import { SnackbarService } from "src/app/shared/components/snackbar/snackbar.service";
import {InsightConfigurationService} from 'src/app/core/services/insight-configuration.service';
import { SnackbarType } from "src/app/shared/components/snackbar/snackbar.enum";
import { IssueModalComponent } from "src/app/shared/components/issue-modal/issue-modal.component";

// 
export enum EWB_MODE {
  STEPS,
  SUBMIT,
  CANCEL,
  BACK
}

@Component({
  selector: 'app-ewb-config',
  templateUrl: './ewb-config.component.html',
  styleUrls: ['./ewb-config.component.scss']
})
export class EwbConfigComponent implements OnInit, AfterViewInit,AfterContentChecked, OnDestroy{
  @ViewChild('stepper1', { static: false }) public stepper1: MatStepper;
  @ViewChild('stepper2', { static: false }) public stepper2: MatStepper;
  
  public selectedIndex = 0;
  public currentStep = 0;
  public showConfigurationDropdown: boolean = false; 
  public showAlgorithmDropdown: boolean = true;
  public isValid: boolean = false;
  public EwbMode =EWB_MODE;
  public rightButtonMode;
  public leftButtonMode;
  public currentSelectedAlgorithm: any;
  public isDisabled: boolean = false;
  public selectedConfigType: any;
  public selectedAsset : any[];
  public configurationDetails : any;
  public selectedImpactedKPIs : SelectedKpi[];
  public unsubscribe  = new Subject<void>();
  public EwbConfiguration : EwbConfiguration;
  public jwtToken:string;
  public steps: Step[];
  public stateSeletedIndex = 0;
  public loading = false;
  public algorithmList: EwbAlgorithmList[];
  public versionList:VersionsList[];
  public selectedAlgorithm: any;

  public isLoading : boolean = true;

  public issueModalRef: BsModalRef;
  public issueModalClosed$ = new Subject<void>();

  public assetsDuplicated: boolean = false; 

  public mode = CONFIG_MODE.CREATE;
  public configurationUpdated = false;
  public disableOnSubmit: boolean = false;
  public token:string;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private readonly store: Store,
    private readonly changeDetectorRef: ChangeDetectorRef,
    public modalService: BsModalService,
    public snackbarService: SnackbarService,
    public InsightConfigurationService:InsightConfigurationService,
  ) { }

  ngOnInit(): void {
    this.rightButtonMode = this.EwbMode.STEPS;
    this.leftButtonMode = this.EwbMode.CANCEL;
    this.mode = this.store.selectSnapshot(state => state.configurations.ewb.mode);
    
    if(this.mode === CONFIG_MODE.EDIT) {
      this.store.dispatch(new MoveStep(EWB_CREATE_COMPONENTS.CONFIGURATIONS));
    } else {
      this.isLoading = true;
      this.store.dispatch(new ClearEwbConfigState());
      this.store.dispatch(new MoveStep(EWB_CREATE_COMPONENTS.ALGORITHM));
      this.getConfigType();
    }
    this.getThemes();
    this.getJWTtoken();
   // this.getEwbModels();
    this.store.select(state => state.configurations.ewb.isAlgoLoading).pipe(takeUntil(this.unsubscribe))
    .subscribe(isAlgoLoading => {
      this.isLoading = isAlgoLoading
    })
  }

  ngAfterViewInit(): void {
    this.getStepStates();
    this.getActiveStepIndex();
    this.listenToAssetDuplicates();
    if(this.mode === CONFIG_MODE.EDIT) {
      this.getEditState();
    }
    this.changeDetectorRef.detectChanges();
    
  }

  ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  
  public navigateToLanding(): void {
    this.store.dispatch(new SetEwbMode(null))
    this.router.navigateByUrl('/home')
  }
public getJWTtoken(){
    return this.store.dispatch(new GetJwtToken()).pipe()
          .subscribe(state => {
            this.token = state.configurations.ewb.token;
            console.log('jwttoken'+this.token)
     })
 }
  
  public getConfigType() {
    this.store.select(state => state.configurations.selectedConfigType).pipe(takeUntil(this.unsubscribe)).subscribe(ConfigType => {
      this.selectedConfigType = ConfigType;
      if(this.selectedConfigType === null) {
        this.navigateToLanding();
      } else {
        this.store.dispatch(new SetThresholdUomConfig(this.selectedConfigType.thresholdUomConfig))
      }
    })
  }


  public submitConfiguration() {
    this.loading = false;
    this.disableOnSubmit = true;
  
    // Trigger submission of configuration via state management
    this.store.dispatch(new SubmitEwbConfiguration())
    .pipe(
      catchError(error => {
        // Handle error from thrown from state
        this.handleCreateConfigError(error)
        return of();
      }),
      takeUntil(this.unsubscribe)
    )
    .subscribe(() => {
      this.disableOnSubmit = true;
      this.snackbarService.show(SnackbarType.SUCCESS, IaConfigStatusHeader.SUCCESS, IaConfigStatusBody.SUCCESS);
      this.store.dispatch(new SetEwbMode(null));
      this.backToLanding();
    })
  }

  public updateConfiguration() {
    this.loading = false;
    this.disableOnSubmit = true;

    this.store.dispatch(new SetEwbMode(null));
    this.store.dispatch(new UpdateConfiguraitonDetails())
    .pipe(
      takeUntil(this.unsubscribe),
      catchError(() => {
        this.snackbarService.show(SnackbarType.FAILED, IaConfigStatusHeader.FAILED, IaConfigStatusBody.UPDATE_FAILED);
        this.backToLanding();
        return of()
      })
    )
    .subscribe(() => {
      this.disableOnSubmit = true;
      this.snackbarService.show(SnackbarType.SUCCESS, IaConfigStatusHeader.SUCCESS, IaConfigStatusBody.UPDATE_SUCCESS);
      this.backToLanding();
    })
  }

  public backToLanding() {
    // Clear the current state of configuration and return to landing page
    this.store.dispatch(new ClearEwbConfigState());
    this.loading = false;
    this.navigateToLanding();
  }

  public handleCreateConfigError(configError: CreateConfigError) {
    if(configError === null) {
      this.snackbarService.show(SnackbarType.FAILED, IaConfigStatusHeader.FAILED, IaConfigStatusBody.FAILED);
      this.store.dispatch(new SetEwbMode(null));
      this.backToLanding();
    } else if(configError.errorCode == EWB_CONFIG_ERROR.CONFIG_EXISTS) {
       // Reload the asset list in the background
       const selectedAlgorithm = this.store.selectSnapshot(state => state.configurations.ewb.selectedAlgorithm);
       this.store.dispatch(new GetAlgorithmAssetList(selectedAlgorithm, true));
       // trigger assets are duplicated
       this.store.dispatch(new SetAssetsDuplicateDetected(true));

       //Get the duplicates
       let duplicateAssets = configError.details.configuredAssets;
       let existingConfigurations = duplicateAssets.map(asset => asset.assetName)
       // Show the issue modal
       this.openIssueModal(existingConfigurations);
   
       // Listen when modal is closed
       const sub = new Subject<void>();
       this.issueModalClosed$.pipe(takeUntil(sub)).subscribe(() => {
         // Redirect to step 2
         this.disableOnSubmit = false;
         this.loading = false;
         this.store.dispatch(new MoveStep(EWB_CREATE_COMPONENTS.ASSETS))
         sub.next();
         sub.complete();
       });
    }
  }

  public getStepStates() {
    this.store.select(state => state.configurations.ewb.steps).pipe(takeUntil(this.unsubscribe)).subscribe(steps => {
      this.steps = steps;
      this.checkActiveComponentValidity();
    })
  }

  public getEditState() {
    this.store.select(state => state.configurations.ewb.configurationUpdated).pipe(takeUntil(this.unsubscribe))
    .subscribe(updated => {
      this.configurationUpdated = updated;
      this.checkActiveComponentValidity();
    })
  }

  public listenToAssetDuplicates() {
    this.store.select(state => state.configurations.ewb.assetsDuplicateDetected).pipe(takeUntil(this.unsubscribe)).subscribe(duplicate => {
      this.assetsDuplicated = duplicate;
    })
  }

  public checkActiveComponentValidity() {
    if(this.mode === CONFIG_MODE.EDIT && this.selectedIndex === EWB_CREATE_COMPONENTS.IMPACTED_KPIS) {
      this.isDisabled = !this.configurationUpdated;
    } else{
      let valid = !!this.steps.find(step => step.stepIndex === this.selectedIndex)?.valid;
      this.isDisabled = !valid;
    }
  }

  public getActiveStepIndex() {
    this.store.select(state => state.configurations.ewb.activeStep).pipe(takeUntil(this.unsubscribe)).subscribe(activeStep => {
      this.selectedIndex = activeStep;
      this.evaluateSteps();
      this.checkActiveComponentValidity();
    })
  }

  public evaluateSteps() {
    if(this.selectedIndex === EWB_CREATE_COMPONENTS.ALGORITHM || this.selectedIndex === EWB_CREATE_COMPONENTS.ASSETS) {
      this.showConfigurationDropdown = false;
      this.showAlgorithmDropdown = true;

      this.stepper1.selectedIndex = this.selectedIndex;
      this.stepper1.selected.completed = this.selectedIndex == 1;
      
    } else if(this.selectedIndex === EWB_CREATE_COMPONENTS.CONFIGURATIONS || this.selectedIndex === EWB_CREATE_COMPONENTS.IMPACTED_KPIS){
      this.showAlgorithmDropdown = false;
      this.showConfigurationDropdown = true;
      this.stepper2.selectedIndex = (this.selectedIndex - 2);
    }
  }

  public onLeftButtonClick() {
    if(this.selectedIndex === EWB_CREATE_COMPONENTS.ALGORITHM) {
      this.store.dispatch(new ClearEwbConfigState())
      this.navigateToLanding();
    } else {
      this.store.dispatch(new MoveStep(--this.selectedIndex));
    }
  }

   public onRightButtonClick() {
    if(this.selectedIndex === EWB_CREATE_COMPONENTS.IMPACTED_KPIS && this.mode === CONFIG_MODE.CREATE) {
      this.submitConfiguration();
    } else if(this.selectedIndex === EWB_CREATE_COMPONENTS.IMPACTED_KPIS && this.mode === CONFIG_MODE.EDIT) {
      this.updateConfiguration();
    } else if(this.selectedIndex < EWB_CREATE_COMPONENTS.IMPACTED_KPIS) {
       this.store.dispatch(new MoveStep(++this.selectedIndex));
    }
   }

   public onRightErrorButtonClick() {
    if(this.selectedIndex == EWB_CREATE_COMPONENTS.ASSETS) {
      // Remove configured assets when clicked
      this.store.dispatch(new RemoveConfiguredAssets())
    }
   }

  public getThemes() {
    let configId = '';
    if(this.mode === CONFIG_MODE.EDIT){
      configId = this.store.selectSnapshot(state => state.configurations.ewb.configurationDetailsSaved?.categoryId);
    }else{
      configId = this.store.selectSnapshot(state => state.configurations.selectedConfigType?.viewId);
    }
    this.store.dispatch(new GetThemes(configId))
  }

//   public getEwbModels(){
//  let configId = '';
//     if(this.mode === CONFIG_MODE.EDIT){
//       configId = this.store.selectSnapshot(state => state.configurations.ewb.configurationDetailsSaved?.categoryId);
//     }else{
//       configId = this.store.selectSnapshot(state => state.configurations.selectedConfigType?.viewId);
//     }
//     this.store.dispatch(new GetAlgorithmList(configId))
//   }
  public algoLoading(algoLoading : any) {
    this.isLoading = algoLoading;
  }

  public openIssueModal(existingConfigurations: string[] = []) {
    this.modalService.show(IssueModalComponent, {
      initialState: {
        title: MODAL_TITLE.SUBMIT_ISSUE,
        message: EWB_CONFIG_ERROR_MODAL_MESSAGE.SUBMIT_ISSUE,
        existingConfigurations: existingConfigurations,
        issueModalClosed$: this.issueModalClosed$
      },
      class: 'message-component issue-modal predictive',
      backdrop: 'static'
    })
  }

  get EWB_CREATE_COMPONENTS() {
    return EWB_CREATE_COMPONENTS;
  }
  get CONFIG_MODE() {
    return CONFIG_MODE;
  }
}
